module.exports = "/images/marker.png?4abf38e215695964b9fff50684bea25b";